export default __webpack_public_path__ + "static/media/Cloud-Upload.75c2180d.svg";